import React from 'react';
import PropTypes from 'prop-types';
import { group, stringInputSpec } from './editing-configs';
import UniversalContainer, {
  universalContainerPropTypes,
} from '../components/universal-container';

const defaultDimensions = {
  height: '232px',
  width: '100%',
};

const renderContent = ({
  soundCloudPlayerColor,
  soundCloudEpisodeId,
  outputSample,
  podcastMediaHight,
  podcastMediaWidth,
}) => {
  const parseColor = (rawColor) => encodeURIComponent(rawColor);
  const src = `https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${soundCloudEpisodeId}&color=${parseColor(
    soundCloudPlayerColor
  )}&auto_play=false&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&visual=true`;

  if ((!soundCloudEpisodeId && outputSample) || !soundCloudEpisodeId) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        width="200px"
        height="auto"
        src="https://www.nerdwallet.com/cdn/img/lpc/soundcloud-logo.png"
        alt="soundcloud logo"
      />
    );
  }

  return (
    <iframe
      id="soundcloud-iframe"
      width={podcastMediaWidth || defaultDimensions.width}
      height={podcastMediaHight || defaultDimensions.height}
      scrolling="no"
      frameBorder="no"
      src={src}
      title="Soundcloud podcast"
    />
  );
};

const SoundCloudPlayer = ({
  soundCloudEpisodeId,
  podcastMediaWidth = defaultDimensions.width,
  podcastMediaHight = defaultDimensions.height,
  soundCloudPlayerColor,
  outputSample,
  mediaContainer,
  includeContainer,
}) => {
  if (includeContainer) {
    return (
      <UniversalContainer {...mediaContainer}>
        {renderContent({
          outputSample,
          podcastMediaHight,
          podcastMediaWidth,
          soundCloudPlayerColor,
          soundCloudEpisodeId,
        })}
      </UniversalContainer>
    );
  }

  return renderContent({
    outputSample,
    podcastMediaHight,
    podcastMediaWidth,
    soundCloudEpisodeId,
  });
};

SoundCloudPlayer.propTypes = {
  soundCloudEpisodeId: PropTypes.string,
  podcastMediaWidth: PropTypes.string,
  podcastMediaHight: PropTypes.string,
  soundCloudPlayerColor: PropTypes.string,
  outputSample: PropTypes.bool,
  includeContainer: PropTypes.bool,
  mediaContainer: universalContainerPropTypes,
};

SoundCloudPlayer.defaultProps = {
  soundCloudEpisodeId: '',
  podcastMediaWidth: '',
  podcastMediaHight: '',
  soundCloudPlayerColor: '#FF5500',
  outputSample: false,
};

SoundCloudPlayer.getEditingConfig = (
  _componentDocument,
  fieldName,
  includeContainer = false
) => {
  const getInputName = (name, topLevel = false) => {
    if (topLevel) {
      return `${fieldName?.split('.').at(-1)}.${name}`;
    }

    if (fieldName) {
      return `${fieldName}.${name}`;
    }
    return name;
  };

  return [
    stringInputSpec(
      getInputName('soundCloudEpisodeId', true),
      'Podcast episode URL'
    ),
    group('Audio Details', [
      {
        help: 'The desired Spotify podcast episode URL',
      },
      stringInputSpec(getInputName('podcastMediaHight'), 'Podcast height', {
        help: 'The podcast frame height in pixels. Default value is 232px',
      }),
      stringInputSpec(getInputName('podcastMediaWidth'), 'Podcast width', {
        help: 'The podcast frame width in pixels or percentage. Default value is 100%',
      }),
      stringInputSpec(
        getInputName('soundCloudPlayerColor'),
        'Play Button Color HEX',
        {
          help: 'Color play button and other controls. e.g. "#FF5500"',
        }
      ),
      ...(includeContainer
        ? [
            ...UniversalContainer.getEditingConfig(
              _componentDocument,
              'Container',
              ['padding', 'margin'],
              getInputName('mediaContainer'),
              { disableGroup: true }
            ),
          ]
        : []),
    ]),
  ];
};

export default SoundCloudPlayer;
